import { size } from '../model/inputs.model'
import imageCompression from 'browser-image-compression'

const imageSize = async (file: any) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const size = {
        width: img.naturalWidth,
        height: img.naturalHeight,
      }
      URL.revokeObjectURL(img.src)
      resolve(size)
    }
    img.onerror = (error) => {
      reject(error)
    }
    img.src = URL.createObjectURL(file)
  })
}

export const getComplessPhoto = async (item: File) => {
  const size = (await imageSize(item)) as size
  const ratio = size['width'] / size['height']
  let maxSize = 330
  if (ratio < 1) {
    maxSize = 330 / ratio
  } else {
    maxSize = 330 * ratio
  }
  const compressOptions = {
    //maxSizeMB: 0.8, //最大ファイルサイズ
    maxWidthOrHeight: maxSize, //最大縦横値
  }
  try {
    let result = {
      blob: await imageCompression(item, compressOptions),
      name: item.name,
    }
    if(result.blob.size > 6000){
      return new File([result.blob], result.name)  
    }
  } catch (error) {
    console.log(error);
  }
}
